import React from 'react'
import Processes from './Processes'
export default function PortfolioManagement() {
  return (
    <div><Processes /></div>
  )
}
